import { WindowResize } from "@aihub/core/utils";
import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef } from "@angular/core";
import { NguCarouselConfig } from "@ngu/carousel";
import { distinctUntilChanged, map } from "rxjs/operators";

/**
 * component which shows up max 3 elements at once, if there are more
 * then enable ngu carousel
 */
@Component({
    selector: "brain-card-list",
    templateUrl: "card-list.html",
    styleUrls: ["./card-list.scss"]
})
export class BrainCardListComponent<T> implements OnInit {

  @Input()
  public source: T[];

  @Input()
  public template: TemplateRef<T>;

  public isMobile = false;

  public constructor(
    private resizeObserver: WindowResize,
    private cdRef: ChangeDetectorRef
  ) {}

  /**
   *
   */
  public tileConfig: NguCarouselConfig = {
      grid: { xs: 1, sm: 2, md: 2, lg: 3, all: 0 },
      slide: 3,
      speed: 250,
      point: { visible: true },
      load: 2,
      velocity: 0,
      touch: true,
      easing: "cubic-bezier(0, 0, 0.2, 1)"
  };

  public ngOnInit(): void {

      this.isMobile = window.innerWidth < 768;

      /** register screen size observer */
      this.resizeObserver.onChange()
          .pipe(
              map(() => window.innerWidth < 768),
              distinctUntilChanged()
          )
          .subscribe((isMobile) => {
              this.isMobile = isMobile;
              this.cdRef.detectChanges();
          });
  }
}
